import { makeStyles } from "@material-ui/core";

export const storageInvoiceItemizedStyles = makeStyles((theme) => ({
    wrapper: {
        marginTop: '1em',

    },
    collapseWrapper: {
        paddingBottom: '2em'
    },
    title: {
        padding: '1em 2em',
    },
    detailsWrapper: {
        padding: '0.5em 2em',
        '& a': {
            textDecoration: 'none !important',
            color: theme.palette.primary.main
        }
    },
    column: {
        fontWeight: 'bold'
    },
    sectionTitle: {
        fontWeight: 'bold',
        color: theme.palette.secondary.light,
        //borderTop: '1px solid ',
        borderColor: '#ccc',
        //background: '#efefef',
        marginTop: '1em',
        padding: '0.5em 2em',
        //textTransform: 'uppercase'
    },
    bundleSummaryRow: {
    },
    bundleVinCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.35rem',
    },
    bundleNameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.4rem',
    },
    bundleToggleIcon: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    bundleToggleButton: {
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    bundleNestedRow: {
    },
    bundleChildVinCell: {
        paddingLeft: '1.65rem',
    },
    bundleDiscountRow: {
        color: theme.palette.error.main,
    },
    pendingBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '10px',
        padding: '0.1rem 0.45rem',
        fontSize: '0.72rem',
        fontWeight: 600,
        color: theme.palette.getContrastText(theme.palette.warning.light),
        backgroundColor: theme.palette.warning.light,
    },
    pendingCharge: {
        color: theme.palette.text.secondary,
        fontWeight: 500,
        whiteSpace: 'nowrap',
    }

}));
